export const DiscussionTopic = 'DiscussionTopic';
export const Idea = 'Idea';

export default Object.freeze({
  DiscussionTopic,
  Idea,
});
